module.exports = __webpack_public_path__ + "img/particle_motion_00106.53a64a09.png";